/**
 * Libellés utilisateur — distinction Relais Public / Relais Privé (PRD 4.27+)
 */

const BASE_USER_TYPE_LABELS = {
  parrain_grand: 'Parrain Grand Électeur',
  parrain_sympa: 'Parrain Sympathisant',
  relais: 'Relais',
  beneficiaire: 'Bénéficiaire',
  gouverneur: 'Gouverneur',
  admin: 'Administrateur',
};

const BASE_USER_TYPE_SHORT_LABELS = {
  parrain_grand: 'Parrain G.',
  parrain_sympa: 'Parrain S.',
  relais: 'Relais',
  beneficiaire: 'Bénéficiaire',
  gouverneur: 'Gouv.',
  admin: 'Admin',
};

/**
 * @param {'public'|'prive'|string|null|undefined} relaisType
 */
export function getRelaisTypeLabel(relaisType) {
  if (relaisType === 'public') return 'Relais Public';
  if (relaisType === 'prive') return 'Relais Privé';
  return 'Relais';
}

/**
 * @param {'public'|'prive'|string|null|undefined} relaisType
 */
export function getRelaisTypeShortLabel(relaisType) {
  if (relaisType === 'public') return 'Relais Pub.';
  if (relaisType === 'prive') return 'Relais Privé';
  return 'Relais';
}

/**
 * @param {string} userType
 * @param {'public'|'prive'|string|null|undefined} [relaisType]
 */
export function getUserTypeLabel(userType, relaisType) {
  if (userType === 'relais') {
    return getRelaisTypeLabel(relaisType ?? null);
  }
  return BASE_USER_TYPE_LABELS[userType] || userType;
}

/**
 * @param {string} userType
 * @param {'public'|'prive'|string|null|undefined} [relaisType]
 */
export function getUserTypeShortLabel(userType, relaisType) {
  if (userType === 'relais') {
    return getRelaisTypeShortLabel(relaisType ?? null);
  }
  return BASE_USER_TYPE_SHORT_LABELS[userType] || getUserTypeLabel(userType, relaisType);
}

/**
 * Resolve relais subtype from API user objects (list vs pending vs profile).
 * @param {{ type?: string, relais_type?: string, relais?: { type?: string } }} user
 */
export function resolveRelaisType(user) {
  if (!user || user.type !== 'relais') return null;
  return user.relais_type || user.relais?.type || null;
}
